// Поле света — то, над чем существует стекло.
//
// Полупрозрачная панель над плоской заливкой стеклом не является: за ней
// нечего преломлять. Поэтому под содержимым лежит мягкое цветное поле, а
// панели прозрачны ровно настолько, чтобы подхватывать его цвет.
//
// Обычно оно одно на всё приложение и смонтировано в App.js. Отдельно его
// подключают только экраны, которые НЕ живут внутри дерева приложения и
// закрывают его собой целиком: замок кода-пароля и вход в веб. Они непрозрачны
// намеренно — за ними не должно просвечивать содержимое кошелька, — и без
// собственного поля оказались бы единственными плоскими экранами продукта.
//
// Геометрия и потолок яркости заданы в styles/glass.css. Потолок 0.28 — не
// вкусовая настройка: на нём держится читаемость текста поверх стекла.
const AmbientField = () => (
  <div className="lp-ambient" aria-hidden="true">
    <i /><i /><i /><i /><i />
  </div>
);

export default AmbientField;
